var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3 11.5702C1.05 11.6702 0.8125 11.6482 0.5875 11.5042C0.3625 11.3607 0.25 11.1514 0.25 10.8764V8.0827C0.25 7.90769 0.3 7.75144 0.4 7.61395C0.5 7.47645 0.6375 7.38895 0.8125 7.35145L6.25 6.00145L0.8125 4.65145C0.6375 4.61395 0.5 4.52645 0.4 4.38895C0.3 4.25145 0.25 4.0952 0.25 3.9202V1.12645C0.25 0.851445 0.3625 0.641946 0.5875 0.497946C0.8125 0.354446 1.05 0.332695 1.3 0.432695L12.85 5.3077C13.1625 5.4452 13.3187 5.67645 13.3187 6.00145C13.3187 6.32645 13.1625 6.5577 12.85 6.6952L1.3 11.5702Z",
    fill: "#6F0D0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSend);
export default __webpack_public_path__ + "static/media/EmailSend.c5865d6655f27e6aa51f89b800d78c27.svg";
export { ForwardRef as ReactComponent };